/**
 * Synchronises Redux `openedModalId` with the imperative `openModal` call
 * for every modal used on the Business Office page.
 * @module useBoModalEffects
 */

import { useEffect } from "react";
import { openModal } from "risa-oasis-ui_v2";
import { ModalId } from "../../../../../enums/modalId";

const BO_MODAL_IDS: ModalId[] = [
  ModalId.COMMENTS_WRITEBACK_VALIDATION_MODAL,
  ModalId.TRIGGER_RPA_MODAL_NEW,
  ModalId.COMMENT_RPA_MODAL_NEW,
  ModalId.HAPPY_FLOW_MODAL,
];

/**
 * Opens the corresponding modal whenever `openedModalId` matches one of
 * the Business Office modal identifiers.
 *
 * @param openedModalId - The currently active modal ID from Redux.
 */
export const useBoModalEffects = (openedModalId: string | null) => {
  useEffect(() => {
    if (openedModalId && BO_MODAL_IDS.includes(openedModalId as ModalId)) {
      openModal(openedModalId as ModalId);
    }
  }, [openedModalId]);
};
